import Bowser from "bowser";

export default () => Bowser.parse(navigator.userAgent);
